import { Injectable } from '@angular/core';

declare var hj: any;

@Injectable()
export class HotjarService {
  private isInitialized = false;
  private isBlocked = false;
  private enabledPages: string[] = [
    '/calculator',
    '/checkout', 
    '/dealerservicecalculator',
    '/dealerservicecheckout'
  ];

  constructor() {
    // Check if Hotjar was blocked at script level
    if (window['hotjarBlocked'] === true) {
      this.isBlocked = true;
    }
    
    // Immediate check for Hotjar availability
    if (typeof hj === 'undefined') {
      this.isBlocked = true;
    }
    
    // Additional checks with delays
    this.checkIfBlocked();
  }

  private checkIfBlocked(): void {
    // Check if Hotjar script failed to load
    setTimeout(() => {
      if (typeof hj === 'undefined') {
        this.isBlocked = true;
      }
    }, 2000); // Wait 2 seconds to see if Hotjar loads

    // Additional check: try to detect if the script element was blocked
    setTimeout(() => {
      const hotjarScript = document.querySelector('script[src*="hotjar"]');
      if (!hotjarScript) {
        this.isBlocked = true;
      }
    }, 1000);
  }

  initialize(hotjarId: string, hotjarSnippetVersion: number = 6): void {
    if (this.isInitialized || this.isBlocked) {
      return;
    }

          try {
        if (typeof hj !== 'undefined') {
          hj('init', hotjarId, hotjarSnippetVersion);
          this.isInitialized = true;
        } else {
          this.isBlocked = true;
        }
      } catch (error) {
        this.isBlocked = true;
      }
  }

  // Check if Hotjar should be active for current page
  shouldActivate(currentPath: string): boolean {
    return this.enabledPages.some(page => currentPath.includes(page));
  }

  // Initialize only for specific pages
  initializeForPage(currentPath: string, hotjarId: string): void {
    if (this.shouldActivate(currentPath)) {
      // Override the Hotjar ID with environment-specific ID
      if (window['_hjSettings']) {
        window['_hjSettings'].hjid = hotjarId;
      }
      this.initialize(hotjarId);
      if (!this.isBlocked) {
        this.stateChange(currentPath);
      }
    }
  }

  trackEvent(eventName: string, properties?: any): void {
    if (this.isInitialized && !this.isBlocked && typeof hj !== 'undefined') {
      try {
        hj('event', eventName, properties);
      } catch (error) {
        // Silent fail
      }
    }
  }

  identify(userId: string, userProperties?: any): void {
    if (this.isInitialized && !this.isBlocked && typeof hj !== 'undefined') {
      try {
        hj('identify', userId, userProperties);
      } catch (error) {
        // Silent fail
      }
    }
  }

  stateChange(relativePath: string): void {
    if (this.isInitialized && !this.isBlocked && typeof hj !== 'undefined') {
      try {
        hj('stateChange', relativePath);
      } catch (error) {
        // Silent fail
      }
    }
  }

  // Method to check if Hotjar is available
  isHotjarAvailable(): boolean {
    return this.isInitialized && !this.isBlocked && typeof hj !== 'undefined';
  }

  // Safe method to track events - won't throw errors
  safeTrackEvent(eventName: string, properties?: any): void {
    if (this.isHotjarAvailable()) {
      this.trackEvent(eventName, properties);
    }
  }

  // Safe method to identify users - won't throw errors
  safeIdentify(userId: string, userProperties?: any): void {
    if (this.isHotjarAvailable()) {
      this.identify(userId, userProperties);
    }
  }

  // Safe method to change state - won't throw errors
  safeStateChange(relativePath: string): void {
    if (this.isHotjarAvailable()) {
      this.stateChange(relativePath);
    }
  }

  // Method to get detailed status for debugging
  getStatus(): any {
    return {
      isInitialized: this.isInitialized,
      isBlocked: this.isBlocked,
      hotjarExists: typeof hj !== 'undefined',
      scriptElement: !!document.querySelector('script[src*="hotjar"]'),
      userAgent: navigator.userAgent
    };
  }

  // Method to force re-check (useful for testing)
  recheckStatus(): void {
    // Silent status check
  }
} 


// WEBPACK FOOTER //
// ./src/app/shared/hotjar.service.ts